const sources = [
  {
    src: '/images/hostel/image1.jpg',
    alt: 'slide-1'
  },
  {
    src: '/images/hostel/image2.jpg',
    alt: 'slide-2'
  },
  {
    src: '/images/hostel/image3.jpg',
    alt: 'slide-3'
  },
  {
    src: '/images/hostel/image4.jpg',
    alt: 'slide-4'
  },
  {
    src: '/images/hostel/image5.jpg',
    alt: 'slide-5'
  },
  {
    src: '/images/hostel/image6.jpg',
    alt: 'slide-6'
  },
  {
    src: '/images/hostel/image7.jpg',
    alt: 'slide-7'
  },
  {
    src: '/images/hostel/image8.jpg',
    alt: 'slide-8'
  },
  {
    src: '/images/hostel/image9.jpg',
    alt: 'slide-9'
  },
  {
    src: '/images/hostel/image10.jpg',
    alt: 'slide-10'
  },
  {
    src: '/images/hostel/image11.jpg',
    alt: 'slide-11'
  },
  {
    src: '/images/hostel/image12.jpg',
    alt: 'slide-12'
  },
];



export { sources };